var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownThick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9207 8.17969H11.6907H6.08072C5.12072 8.17969 4.64073 9.33969 5.32073 10.0197L10.5007 15.1997C11.3307 16.0297 12.6807 16.0297 13.5107 15.1997L15.4807 13.2297L18.6907 10.0197C19.3607 9.33969 18.8807 8.17969 17.9207 8.17969Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownThick);
export default __webpack_public_path__ + "static/media/arrowDownThick.867761cb7eeb6f35147938ff43efec3e.svg";
export { ForwardRef as ReactComponent };